import { closeModal, openModal } from "../../../ui/containers/Modal";
import { floodFill } from "../../../ui/helpers";
import { ButtonComp } from "../../../ui/input/Button";
import { TextType } from "../../../ui/type/TextType";
import { ComponentF, createElement } from "../../../ui/ui";
import Colors from "../../Colors";
import { PlayerPosition } from "./PlayerPosition";
import { LevelModal } from "../level/LevelModal";

export const CheatModal: ComponentF<{
  title: string;
  keys: string | string[];
  onClick: () => void;
}> = (C, props) => {
  floodFill(C.display, C.bounds, Colors.BLACK);
  return [
    createElement(
      TextType,
      { x: 0, y: 0, w: 24, h: 1 },
      { title: "Cheat Menu Options" }
    ),
    createElement(PlayerPosition, { x: 0, y: 1, w: 40, h: 1 }),
    createElement(
      ButtonComp,
      { x: 2, y: 14, w: 6, h: 1 },
      {
        title: "Level",
        onClick: () => {
          closeModal();
          openModal(
            createElement(LevelModal, { x: 0, y: 0, w: 48, h: 24 }, {})
          );
        },
      }
    ),
    createElement(
      ButtonComp,
      { x: 2, y: 16, w: 6, h: 1 },
      { title: "Close", onClick: () => closeModal() }
    ),
  ];
};
